import { render } from "./PrcEdit.vue?vue&type=template&id=732666f8"
import script from "./PrcEdit.vue?vue&type=script&lang=js"
export * from "./PrcEdit.vue?vue&type=script&lang=js"

import "./PrcEdit.vue?vue&type=style&index=0&id=732666f8&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__